import * as React from 'react';

import type * as api from '@gitbook/api-client';
import { intlPluralizeString } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import { Button, LoadingPanel } from '@gitbook/spine-react';

import { AISearchAnswerSources } from './AISearchAnswerSources';

/**
 * The section in the AI answer that displays the sources
 */
export function AISearchAnswerSourcesSection(props: {
    answer: api.SearchAIAnswer;
}): React.ReactElement {
    const { answer } = props;
    const [opened, setOpened] = React.useState(false);

    return (
        <div className="flex w-full flex-col gap-4">
            <div className="flex flex-1">
                <Button
                    kind="blank"
                    size="small"
                    trailingIcon={opened ? Icon.ChevronDown : Icon.ChevronRight}
                    onPress={() => {
                        setOpened(!opened);
                    }}
                    className="p-0"
                    preventFocusOnPress
                    label={
                        answer?.answer
                            ? `Based on ${answer.sources.length} ${intlPluralizeString({
                                  count: answer.sources.length,
                                  singular: 'source',
                                  plural: 'sources',
                              })}`
                            : `Found ${
                                  answer.sources.length
                              } potentially related ${intlPluralizeString({
                                  count: answer.sources.length,
                                  singular: 'source',
                                  plural: 'sources',
                              })}`
                    }
                />
            </div>

            {opened ? (
                <React.Suspense fallback={<LoadingPanel size="medium" />}>
                    <AISearchAnswerSources answer={answer} />
                </React.Suspense>
            ) : null}
        </div>
    );
}
